// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_5y-0";
export var eligibilityCardNotEligible = "_5y-1";